module.exports = __webpack_public_path__ + "4dba973b38ab20d3321a60690babe478.pdf";